import { PageFlow } from '@fullstory/proto/fs/api/metrics/pagemetrics';
import { PageDefinition } from '@fullstory/proto/fs/api/pages';
import { createContext, useContext } from 'react';
import { GraphNode, PageType } from './types';

export const PageFlowContext = createContext<{
  onWatchSessions: (pageDefId?: number, type?: PageType) => void;
  isEdit: boolean;
  page: PageFlow;
  selectedNode: GraphNode | null;
  onSelectNode: (node: GraphNode | null) => void;
  hoveredNode: GraphNode | null;
  onHoverNode: (node: GraphNode | null) => void;
  getPageDefTooltip: (pageDefId: number) => React.ReactNode;
  pageDefinition: PageDefinition | undefined;
}>({
  onWatchSessions: () => {},
  isEdit: false,
  page: {} as PageFlow,
  selectedNode: null,
  onSelectNode: () => {},
  hoveredNode: null,
  onHoverNode: () => {},
  getPageDefTooltip: () => undefined,
  pageDefinition: undefined,
});

export const usePageFlow = () => {
  const pageFlow = useContext(PageFlowContext);

  if (pageFlow === undefined) {
    throw new Error('usePageFlow must be used within a <PageFlow /> component');
  }

  return pageFlow;
};
